export const API_BASE = process.env.REACT_APP_API_BASE || '/api/v1';
export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';
